export enum StageKind {
  Lead = "lead"
}

export enum StageGroup {
  LeadPipeline = "lead_pipeline",
  ApplicationPipeline = "application_pipeline",
  OwnerPipeline = "owner_pipeline"
}

export interface Stage {
  id: number;
  name: string;
  color: string;
  is_fixed: boolean;
  position: number | string;
  kind?: StageKind;
}

export interface CreateStagePayload {
  kind: StageKind;
  name: string;
  color: string;
  stage_group?: StageGroup;
  is_fixed?: boolean;
  before_stage_id?: number | null;
  after_stage_id?: number | null;
}

export interface UpdateStagePayload {
  name?: string | null;
  color?: string | null;
  before_stage_id?: number | null;
  after_stage_id?: number | null;
}

export interface DeleteStagePayload {
  replacement_stage_id?: number;
}

export interface StageDeleteConflictResponse {
  is_conflict: boolean;
}
